import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import {
  useRentalManagerUserPropertyCriteriaWebApiHandler_get,
  useRentalManagerUserPropertyCriteriaWebApiHandler_set,
} from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

import PropertiesActions from '../../actions/PropertiesActions';

import ListingCriteria from '../../model/ListingCriteria';

const useGetListingCriteria = (queryParams: { propertyId: string }) => {
  const dispatch = useDispatch();

  const queryHook = useRentalManagerUserPropertyCriteriaWebApiHandler_get(
    { listingAlias: queryParams.propertyId },
    {
      meta: {
        context: {
          api: 'rental-manager',
          details: 'useRentalManagerUserPropertyCriteriaWebApiHandler_get',
        },
        tags: ['users-properties-criteria-get'],
      },
      staleTime: 0,
      retry: 3,
    },
  );

  const { data } = queryHook;

  useEffect(() => {
    if (!data) return;

    const { criteria, isEnabled, price, isFeed } = data;

    dispatch(
      PropertiesActions.updateCurrentProperty({
        listingCriteria: ListingCriteria({
          isEnabled,
          criteria,
        }),
        price,
        isFeed,
      }),
    );
  }, [data, dispatch]);

  return queryHook;
};

const useSetListingCriteria = () =>
  useRentalManagerUserPropertyCriteriaWebApiHandler_set({
    meta: {
      context: {
        api: 'rental-manager',
        details: 'useRentalManagerUserPropertyCriteriaWebApiHandler_set',
      },
      invalidates: ['users-properties-criteria-set', 'users-properties-criteria-get'],
    },
  });

export { useGetListingCriteria, useSetListingCriteria };
